package us.laantech.common.util

/** Parse common CSV truthy/falsy spellings (case-insensitive): 1/0, true/false, yes/no, y/n. */
fun String.toBooleanLooseOrNull(): Boolean? = when (trim().lowercase()) {
    "1", "true", "yes", "y", "t" -> true
    "0", "false", "no", "n", "f" -> false
    else -> null
}
